// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  align-items: center;
  background: var(--overlay-bg);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 2000;
}

.login-modal {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  box-shadow: 0 4px 16px var(--shadow-color);
  margin: 50px auto;
  min-width: 302px;
  overflow: auto;
  padding: 0;
  z-index: 1000;
}

@media screen and (max-width: 401px) {
  .login-modal {
    width: 100vw !important;
    max-width: 100vw !important;
    min-width: 100vw !important;
    margin: 0;
    position: fixed;
  }
}

.login-modal .modal-header {
  align-items: center;
  border-bottom: 1px solid var(--border-color);
  display: flex;
  justify-content: space-between;
  padding: 20px 24px;
}

.login-modal .modal-header h2 {
  margin: 0;
  font-size: 20px;
  color: var(--text-primary);
  font-weight: 700;
}

.login-modal .close-btn,
.pin-modal .close-btn {
  align-items: center;
  background: none;
  border: none;
  border-radius: 50%;
  color: var(--text-secondary);
  cursor: pointer;
  display: flex;
  font-size: 24px;
  height: 30px;
  justify-content: center;
  padding: 0;
  transition: background-color .2s;
  width: 30px;
}

.login-modal .close-btn:hover,
.pin-modal .close-btn:hover {
  background-color: var(--bg-tertiary);
}

.login-modal .modal-tabs {
  display: flex;
  border-bottom: 1px solid var(--border-color);
}

.login-modal .tab-btn {
  flex: 1 1;
  padding: 16px;
  background: none;
  border: none;
  font-size: 15px;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
}

.login-modal .tab-btn:hover {
  color: var(--text-primary);
  background-color: var(--bg-tertiary);
}

.login-modal .tab-btn.active {
  color: var(--accent-primary);
  border-bottom-color: var(--accent-primary);
}

.login-modal .modal-content {
  padding: 24px;
  width: auto;
  max-width: 700px;
  max-height: none;
  background: none;
  border: none;
  border-radius: 0;
  box-shadow: none;
  animation: none;
}

.login-modal .form-group,
.pin-modal .form-group {
  margin-bottom: 20px;
}

.login-modal .form-group label,
.pin-modal .form-group label {
  display: block;
  margin-bottom: 4px;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}

.login-modal .form-group input,
.pin-modal .form-group input {
  width: 100%;
  padding: 12px;
  border: 1px solid var(--input-border);
  border-radius: 8px;
  font-size: 14px;
  box-sizing: border-box;
  transition: border-color 0.2s;
  background: var(--input-bg);
  color: var(--input-text);
}

.login-modal .form-group input:focus,
.pin-modal .form-group input:focus {
  outline: none;
  border-color: var(--accent-primary);
}

.login-modal .form-group .hint {
  font-size: 12px;
  color: var(--text-secondary);
  margin-top: 6px;
  display: block;
}

.login-modal .pin-input,
.pin-modal .pin-input {
  font-family: monospace;
  letter-spacing: 8px;
  text-align: center;
  font-size: 20px;
}

.login-modal .error-message,
.pin-modal .error-message {
  background-color: var(--error-bg);
  color: var(--error-color);
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 16px;
  font-size: 14px;
  border-left: 3px solid var(--error-color);
}

.login-modal .login-btn,
.pin-modal .login-btn {
  width: 100%;
  padding: 12px;
  background-color: var(--accent-primary);
  color: var(--bg-secondary);
  border: none;
  border-radius: 20px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.2s;
}

.login-modal .login-btn:hover:not(:disabled),
.pin-modal .login-btn:hover:not(:disabled) {
  background-color: var(--accent-hover);
}

.login-modal .login-btn:disabled,
.pin-modal .login-btn:disabled {
  background-color: var(--text-tertiary);
  cursor: not-allowed;
  opacity: 0.6;
}

.login-modal .keychain-section {
  text-align: center;
}

.login-modal .keychain-section p {
  margin-bottom: 20px;
  color: var(--text-secondary);
  font-size: 14px;
  line-height: 1.5;
}

.login-modal .keychain-logo {
  font-size: 48px;
  margin-bottom: 16px;
}

.login-modal .info-box {
  background-color: var(--bg-tertiary);
  border-left: 3px solid var(--like-color);
  padding: 12px 16px;
  margin-bottom: 20px;
  font-size: 13px;
  color: var(--text-primary);
  border-radius: 8px;
  line-height: 1.5;
}

.login-modal .info-box a {
  color: var(--accent-primary);
  font-weight: 600;
  text-decoration: none;
}

.login-modal .info-box a:hover {
  text-decoration: underline;
}

/* Saved Accounts Section */
.login-modal .saved-accounts-section {
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 2px solid var(--border-color);
}

.login-modal .saved-accounts-section h3 {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 12px;
}

.login-modal .saved-accounts-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
}

.login-modal .saved-account-item {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
  background: var(--bg-tertiary);
  border-radius: 8px;
  padding: 6px;
  transition: background 0.2s;
  border: 1px solid var(--border-color);
}

.login-modal .saved-account-item:hover {
  background: var(--bg-secondary);
  border-color: var(--accent-primary);
}

.login-modal .saved-account-btn {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 12px;
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  text-align: left;
  color: var(--text-primary);
}

.login-modal .saved-account-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

.login-modal .saved-account-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
}

.login-modal .saved-account-btn .checkmark {
  color: var(--accent-primary);
  font-weight: 700;
  margin-left: auto;
  font-size: 18px;
}

.login-modal .delete-account-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--error-bg);
  border: none;
  color: var(--error-color);
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.login-modal .delete-account-btn:hover {
  background: var(--error-color);
  color: var(--bg-secondary);
}

/* PIN Modal */
.pin-modal {
  background: var(--bg-secondary);
  border-radius: 12px;
  padding: 24px;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 4px 16px var(--shadow-color);
}

.pin-modal .modal-header {
  padding: 0 0 16px 0;
  border-bottom: 1px solid var(--border-color);
  margin-bottom: 20px;
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.pin-modal .modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: var(--text-primary);
  font-weight: 700;
}

.pin-modal .form-group {
  margin-bottom: 16px;
}

/* Web2 Section */
.login-modal .web2-section {
  padding: 0;
}

.login-modal .web2-section .info-box.warning {
  background: var(--bg-tertiary);
  border-color: var(--border-color);
}

.login-modal .web2-section .hint.success {
  color: var(--success-color);
}

.login-modal .web2-section .hint.error {
  color: var(--error-color);
}

.login-modal .auth-footer {
  margin-top: 20px;
  text-align: center;
  padding-top: 16px;
  border-top: 1px solid var(--border-color);
}

.login-modal .auth-footer p {
  margin: 0;
  color: var(--text-secondary);
  font-size: 14px;
}

.login-modal .link-button {
  background: none;
  border: none;
  color: var(--accent-primary);
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  padding: 0;
  text-decoration: none;
}

.login-modal .link-button:hover {
  text-decoration: underline;
}

.login-modal .divider {
  text-align: center;
  margin: 20px 0;
  color: var(--text-secondary);
  font-size: 14px;
  position: relative;
}

.login-modal .divider::before,
.login-modal .divider::after {
  content: '';
  position: absolute;
  top: 50%;
  width: 40%;
  height: 1px;
  background: var(--border-color);
}

.login-modal .divider::before {
  left: 0;
}

.login-modal .divider::after {
  right: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/LoginModal/LoginModal.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,OAAO;EACP,eAAe;EACf,MAAM;EACN,WAAW;EACX,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,aAAa;AACf;;AAEA;EACE;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,SAAS;IACT,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,gCAAgC;EAChC,WAAW;AACb;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,6BAA6B;EAC7B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,iCAAiC;EACjC,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,uCAAuC;EACvC,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,sCAAsC;EACtC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA,cAAc;AACd;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV","sourcesContent":[".modal-overlay {\r\n  align-items: center;\r\n  background: var(--overlay-bg);\r\n  display: flex;\r\n  height: 100%;\r\n  justify-content: center;\r\n  left: 0;\r\n  position: fixed;\r\n  top: 0;\r\n  width: 100%;\r\n  z-index: 2000;\r\n}\r\n\r\n.login-modal {\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 16px var(--shadow-color);\r\n  margin: 50px auto;\r\n  min-width: 302px;\r\n  overflow: auto;\r\n  padding: 0;\r\n  z-index: 1000;\r\n}\r\n\r\n@media screen and (max-width: 401px) {\r\n  .login-modal {\r\n    width: 100vw !important;\r\n    max-width: 100vw !important;\r\n    min-width: 100vw !important;\r\n    margin: 0;\r\n    position: fixed;\r\n  }\r\n}\r\n\r\n.login-modal .modal-header {\r\n  align-items: center;\r\n  border-bottom: 1px solid var(--border-color);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 20px 24px;\r\n}\r\n\r\n.login-modal .modal-header h2 {\r\n  margin: 0;\r\n  font-size: 20px;\r\n  color: var(--text-primary);\r\n  font-weight: 700;\r\n}\r\n\r\n.login-modal .close-btn,\r\n.pin-modal .close-btn {\r\n  align-items: center;\r\n  background: none;\r\n  border: none;\r\n  border-radius: 50%;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n  display: flex;\r\n  font-size: 24px;\r\n  height: 30px;\r\n  justify-content: center;\r\n  padding: 0;\r\n  transition: background-color .2s;\r\n  width: 30px;\r\n}\r\n\r\n.login-modal .close-btn:hover,\r\n.pin-modal .close-btn:hover {\r\n  background-color: var(--bg-tertiary);\r\n}\r\n\r\n.login-modal .modal-tabs {\r\n  display: flex;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.login-modal .tab-btn {\r\n  flex: 1;\r\n  padding: 16px;\r\n  background: none;\r\n  border: none;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n  border-bottom: 2px solid transparent;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.login-modal .tab-btn:hover {\r\n  color: var(--text-primary);\r\n  background-color: var(--bg-tertiary);\r\n}\r\n\r\n.login-modal .tab-btn.active {\r\n  color: var(--accent-primary);\r\n  border-bottom-color: var(--accent-primary);\r\n}\r\n\r\n.login-modal .modal-content {\r\n  padding: 24px;\r\n  width: auto;\r\n  max-width: 700px;\r\n  max-height: none;\r\n  background: none;\r\n  border: none;\r\n  border-radius: 0;\r\n  box-shadow: none;\r\n  animation: none;\r\n}\r\n\r\n.login-modal .form-group,\r\n.pin-modal .form-group {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.login-modal .form-group label,\r\n.pin-modal .form-group label {\r\n  display: block;\r\n  margin-bottom: 4px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.login-modal .form-group input,\r\n.pin-modal .form-group input {\r\n  width: 100%;\r\n  padding: 12px;\r\n  border: 1px solid var(--input-border);\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  box-sizing: border-box;\r\n  transition: border-color 0.2s;\r\n  background: var(--input-bg);\r\n  color: var(--input-text);\r\n}\r\n\r\n.login-modal .form-group input:focus,\r\n.pin-modal .form-group input:focus {\r\n  outline: none;\r\n  border-color: var(--accent-primary);\r\n}\r\n\r\n.login-modal .form-group .hint {\r\n  font-size: 12px;\r\n  color: var(--text-secondary);\r\n  margin-top: 6px;\r\n  display: block;\r\n}\r\n\r\n.login-modal .pin-input,\r\n.pin-modal .pin-input {\r\n  font-family: monospace;\r\n  letter-spacing: 8px;\r\n  text-align: center;\r\n  font-size: 20px;\r\n}\r\n\r\n.login-modal .error-message,\r\n.pin-modal .error-message {\r\n  background-color: var(--error-bg);\r\n  color: var(--error-color);\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  margin-bottom: 16px;\r\n  font-size: 14px;\r\n  border-left: 3px solid var(--error-color);\r\n}\r\n\r\n.login-modal .login-btn,\r\n.pin-modal .login-btn {\r\n  width: 100%;\r\n  padding: 12px;\r\n  background-color: var(--accent-primary);\r\n  color: var(--bg-secondary);\r\n  border: none;\r\n  border-radius: 20px;\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.login-modal .login-btn:hover:not(:disabled),\r\n.pin-modal .login-btn:hover:not(:disabled) {\r\n  background-color: var(--accent-hover);\r\n}\r\n\r\n.login-modal .login-btn:disabled,\r\n.pin-modal .login-btn:disabled {\r\n  background-color: var(--text-tertiary);\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n}\r\n\r\n.login-modal .keychain-section {\r\n  text-align: center;\r\n}\r\n\r\n.login-modal .keychain-section p {\r\n  margin-bottom: 20px;\r\n  color: var(--text-secondary);\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.login-modal .keychain-logo {\r\n  font-size: 48px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.login-modal .info-box {\r\n  background-color: var(--bg-tertiary);\r\n  border-left: 3px solid var(--like-color);\r\n  padding: 12px 16px;\r\n  margin-bottom: 20px;\r\n  font-size: 13px;\r\n  color: var(--text-primary);\r\n  border-radius: 8px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.login-modal .info-box a {\r\n  color: var(--accent-primary);\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n}\r\n\r\n.login-modal .info-box a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Saved Accounts Section */\r\n.login-modal .saved-accounts-section {\r\n  margin-bottom: 24px;\r\n  padding-bottom: 24px;\r\n  border-bottom: 2px solid var(--border-color);\r\n}\r\n\r\n.login-modal .saved-accounts-section h3 {\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.login-modal .saved-accounts-list {\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n}\r\n\r\n.login-modal .saved-account-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  flex: 0 0 auto;\r\n  background: var(--bg-tertiary);\r\n  border-radius: 8px;\r\n  padding: 6px;\r\n  transition: background 0.2s;\r\n  border: 1px solid var(--border-color);\r\n}\r\n\r\n.login-modal .saved-account-item:hover {\r\n  background: var(--bg-secondary);\r\n  border-color: var(--accent-primary);\r\n}\r\n\r\n.login-modal .saved-account-btn {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  background: none;\r\n  border: none;\r\n  padding: 4px;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.login-modal .saved-account-avatar {\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n}\r\n\r\n.login-modal .saved-account-name {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.login-modal .saved-account-btn .checkmark {\r\n  color: var(--accent-primary);\r\n  font-weight: 700;\r\n  margin-left: auto;\r\n  font-size: 18px;\r\n}\r\n\r\n.login-modal .delete-account-btn {\r\n  width: 28px;\r\n  height: 28px;\r\n  border-radius: 50%;\r\n  background: var(--error-bg);\r\n  border: none;\r\n  color: var(--error-color);\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.login-modal .delete-account-btn:hover {\r\n  background: var(--error-color);\r\n  color: var(--bg-secondary);\r\n}\r\n\r\n/* PIN Modal */\r\n.pin-modal {\r\n  background: var(--bg-secondary);\r\n  border-radius: 12px;\r\n  padding: 24px;\r\n  max-width: 400px;\r\n  width: 90%;\r\n  box-shadow: 0 4px 16px var(--shadow-color);\r\n}\r\n\r\n.pin-modal .modal-header {\r\n  padding: 0 0 16px 0;\r\n  border-bottom: 1px solid var(--border-color);\r\n  margin-bottom: 20px;\r\n  align-items: center;\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.pin-modal .modal-header h3 {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  color: var(--text-primary);\r\n  font-weight: 700;\r\n}\r\n\r\n.pin-modal .form-group {\r\n  margin-bottom: 16px;\r\n}\r\n\r\n/* Web2 Section */\r\n.login-modal .web2-section {\r\n  padding: 0;\r\n}\r\n\r\n.login-modal .web2-section .info-box.warning {\r\n  background: var(--bg-tertiary);\r\n  border-color: var(--border-color);\r\n}\r\n\r\n.login-modal .web2-section .hint.success {\r\n  color: var(--success-color);\r\n}\r\n\r\n.login-modal .web2-section .hint.error {\r\n  color: var(--error-color);\r\n}\r\n\r\n.login-modal .auth-footer {\r\n  margin-top: 20px;\r\n  text-align: center;\r\n  padding-top: 16px;\r\n  border-top: 1px solid var(--border-color);\r\n}\r\n\r\n.login-modal .auth-footer p {\r\n  margin: 0;\r\n  color: var(--text-secondary);\r\n  font-size: 14px;\r\n}\r\n\r\n.login-modal .link-button {\r\n  background: none;\r\n  border: none;\r\n  color: var(--accent-primary);\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  padding: 0;\r\n  text-decoration: none;\r\n}\r\n\r\n.login-modal .link-button:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.login-modal .divider {\r\n  text-align: center;\r\n  margin: 20px 0;\r\n  color: var(--text-secondary);\r\n  font-size: 14px;\r\n  position: relative;\r\n}\r\n\r\n.login-modal .divider::before,\r\n.login-modal .divider::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 50%;\r\n  width: 40%;\r\n  height: 1px;\r\n  background: var(--border-color);\r\n}\r\n\r\n.login-modal .divider::before {\r\n  left: 0;\r\n}\r\n\r\n.login-modal .divider::after {\r\n  right: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
